/**
 * Maps iOS activity types to human-readable platform names
 * Used for tracking which platform users share to
 */
export function mapActivityTypeToPlatform(activityType) {
  if (!activityType) {
    return 'unknown';
  }

  const activityTypeStr = String(activityType).toLowerCase();

  // Facebook
  if (activityTypeStr.includes('facebook')) {
    return 'facebook';
  }

  // Twitter/X
  if (activityTypeStr.includes('twitter')) {
    return 'twitter';
  }

  // WhatsApp (usually via Message activity)
  if (activityTypeStr.includes('whatsapp') || activityTypeStr.includes('message')) {
    // Note: Message activity can be iMessage, WhatsApp, or other messaging apps
    // We can't distinguish between them, so we'll use 'message' as generic
    return 'message';
  }

  // Email
  if (activityTypeStr.includes('mail')) {
    return 'email';
  }

  // AirDrop
  if (activityTypeStr.includes('airdrop')) {
    return 'airdrop';
  }

  // Copy to clipboard
  if (activityTypeStr.includes('pasteboard') || activityTypeStr.includes('copy')) {
    return 'clipboard';
  }

  // Weibo
  if (activityTypeStr.includes('weibo')) {
    return 'weibo';
  }

  // Flickr
  if (activityTypeStr.includes('flickr')) {
    return 'flickr';
  }

  // Vimeo
  if (activityTypeStr.includes('vimeo')) {
    return 'vimeo';
  }

  // Save to camera roll
  if (activityTypeStr.includes('camera') || activityTypeStr.includes('save')) {
    return 'camera_roll';
  }

  // Generic share (for other apps)
  return 'other';
}

